/* eslint-disable react/self-closing-comp */
/* eslint-disable import/named */
/* eslint-disable prefer-template */
/* eslint-disable one-var */
/* eslint-disable radix */
/* eslint-disable no-else-return */
/* eslint-disable no-shadow */
/* eslint-disable react/no-unused-prop-types */
/* eslint-disable react/prop-types */
/* eslint-disable no-unused-expressions */
/* eslint-disable react/jsx-boolean-value */
/* eslint-disable vars-on-top */
/* eslint-disable eqeqeq */
/* eslint-disable array-callback-return */
/* eslint-disable consistent-return */
/* eslint-disable prefer-destructuring */
/* eslint-disable no-var */
/* eslint-disable camelcase */
/* eslint-disable arrow-body-style */
/* eslint-disable no-undef */
/* eslint-disable jsx-a11y/label-has-associated-control */
/* eslint-disable jsx-a11y/no-static-element-interactions */
/* eslint-disable jsx-a11y/click-events-have-key-events */
/* eslint-disable object-shorthand */
/* eslint-disable no-unused-vars */
/* eslint-disable no-use-before-define */
/* eslint-disable prefer-const */
/* eslint-disable dot-notation */
/* eslint-disable no-nested-ternary */
import React, { useEffect, useState } from "react";
import { useSelector, useDispatch } from "react-redux";

import { useHistory, useLocation } from "react-router-dom";
import Button from '@mui/material/Button';
import { Grid } from "@material-ui/core";
import ArticleIcon from '@mui/icons-material/Article';
import AccessTimeFilledIcon from '@mui/icons-material/AccessTimeFilled';
import BriefCase from "../../assets/svg/briefcase";
import GroupIcon from "../../assets/svg/user";
import styles from "./Landing.module.css";
import {
  MESSAGE_TYPE,
} from "../../constants";
import { useAuthorizationContext } from "../../providers/AuthorizationHandler/AuthorizationHandler";
import { usePopupManager } from "../../providers/PopupManager/PopupManager";
import { setLogin } from "../../redux/features/auth/actions";
import Announcement from "./Announcement";
import Truckloading from "../../components/CvLoader/Cvloader";
import { sanitizeCoCodeNumeric, sanitizeNumeric } from "../../utils/utils";
import apiService from "../../apis/apiService";



const LandingPage = () => {
  const { isAuthenticated, user, authResources } = useAuthorizationContext();
  const history = useHistory();
  const location = useLocation();
  const dispatch = useDispatch();
  const [loading, setLoading] = React.useState(false);
  // eslint-disable-next-line no-unused-vars
  const { showPopup } = usePopupManager();
  const auth = useSelector((state) => state.auth);
  const [isMobile, setIsMobile] = useState(false);
  const [path, setPath] = useState("");
  const [accessAndRoleManagementStatusCountData, setAccessAndRoleManagementStatusCountData] = useState({})
  const [projectLinkageStatusCountData, setProjectLinkageStatusCountData] = useState({})
  const baseUrl = useSelector((state) => state.counter.baseUrl);
  const [pendingCount,setPendingCount]=useState([]);
  const [unBookedUnreviewed,setunBookedUnreviewed]=useState([]);
  const [reporteeUnbook,setReporteeUnbook]=useState([]);
  const [operavtiveData,setOperativeData]=useState([])
  const [accessandRoleDisable, setAccessandRoleDisable] = useState(false);
  const [linkageProjectDisable, setLinkageProjectDisable] = useState(false);
  const [Linkage_buttonStyle, setLinkage_buttonStyle] = useState({textTransform: 'none'});
  const [Requestor_buttonStyle, setRequestor_buttonStyle] = useState({textTransform: 'none'});

  let ipAddress2=false
  ipAddress2=auth?.ip_address?.startsWith("intranet")

  useEffect(() => {
    if (location.pathname == "/") {
      setPath("/home");    
    } else {
      setPath(location.pathname);
    }
  }, [location]);

  useEffect(() => {
    const isMobileDevice = /Mobi/.test(window.navigator.userAgent);
    if (isMobileDevice) {
      setIsMobile(isMobileDevice);
    } else {
      setIsMobile(false);
    }
  }, [isMobile]);

  let managerRole=auth.userRole.includes("M")
  let dsReviewRole=auth.userRole.includes("DS")
  let supervisorRole=auth.userRole.includes("S")
  
 
  const getAccessAndRoleManagementStatusCount = async() => {
    setLoading(true)
    try {
      const body = {
        pers_no: sanitizeNumeric(auth.personNumber)
      }
      const response = await apiService.handleAccessAndRoleManagementStatusCount(body, dispatch)
      dispatch(setLogin({...auth, recentStatus:response.status}))
      if(response.msg === 'Success'){
        setLoading(false)
        setAccessAndRoleManagementStatusCountData(response?.data)
      }
    } catch (error) {
      setLoading(false)
      dispatch(setLogin({...auth, recentStatus: error.response.status })); 
    }finally{
      setLoading(false)
    }
  }

  const getProjectLinkageStatusCount =async () => {
    try {
      setLoading(true)
      let apiFormatedData = {
        "pers_no": sanitizeNumeric(auth.personNumber)  
      };     
      const response = await apiService.getProjectLinkageStatusCount(apiFormatedData, dispatch)
      dispatch(setLogin({...auth, recentStatus: response.status}))    
      if(response.msg === "Success" ){
        setLoading(false)
        setProjectLinkageStatusCountData(response.data) 
      }      
    } catch (error) {
      setLoading(false)  
    } finally{
      setLoading(false)
    }
  }

  const PendingApprovalCount =async()=>{
    try {
      setLoading(true)
      let apiFormatedData = {
        "pers_no": sanitizeNumeric(auth.personNumber) 
      };
      const response = await apiService.getPendingApprovalCount(apiFormatedData, dispatch);
      dispatch(setLogin({...auth, recentStatus: response.status}))      
      if(response.msg=="Success"){
        setPendingCount(response)
        setLoading(false)
      }      
    } catch (error) {
      setLoading(false)
    } finally{
      setLoading(false)
    }
  }

  const getdeptspocUnbookedUnreviewedHRS=async()=>{
    try {
      setLoading(true)
      let apiFormatedData = {
        "pers_no": sanitizeNumeric(auth.personNumber) ,
        'co_code':sanitizeCoCodeNumeric(auth.companyCode)
      }; 
      const response = await apiService.getUnbookedUnreviewedHRS(apiFormatedData, dispatch)
      dispatch(setLogin({...auth, recentStatus: response.status}))
      if(response.msg == "Success"){
        setLoading(false)
        setunBookedUnreviewed(response)
      } 
      
    } catch (error) {
      setLoading(false)
    } finally{
      setLoading(false)
    }
  }

  const ReporteeUnbookedHrsCount=async()=>{
    try {
      setLoading(true)
      let apiFormatedData = {
      "pers_no": sanitizeNumeric(auth.personNumber) ,
       'co_code':sanitizeCoCodeNumeric(auth.companyCode)
      };    
      const response = await apiService.getReporteeUnbookedHrsCount(apiFormatedData, dispatch);
      dispatch(setLogin({...auth, recentStatus: response.status}))   
      if(response.msg == "Success"){
        setReporteeUnbook(response)
        setLoading(false)
      }      
    } catch (error) {
      setLoading(false) 
    } finally{
      setLoading(false)
    }
  }

  const OperativeUnbookedHrs=async()=>{
    try {
      setLoading(true)
      let apiFormatedData = {
        "pers_no": sanitizeNumeric(auth.personNumber) ,
        'co_code':sanitizeCoCodeNumeric(auth.companyCode)
      };     
      const response = await apiService.getOperativeUnbookedHrs(apiFormatedData, dispatch)
      dispatch(setLogin({...auth, recentStatus: response.status}))
      if(response.msg == "Success"){
        setLoading(false)
        setOperativeData(response)
      } 
    } catch (error) {
      setLoading(false)    
    } finally{
      setLoading(false)
    }
  }

  useEffect(()=>{
      getAccessAndRoleManagementStatusCount()
      getProjectLinkageStatusCount()
      if(managerRole){
        PendingApprovalCount()
        ReporteeUnbookedHrsCount()
      }
      if(dsReviewRole){
        getdeptspocUnbookedUnreviewedHRS()
      }
      if(supervisorRole){
        OperativeUnbookedHrs()
      }
    
    const includesSaOrB = auth.userRole.some(item => item.includes('SA') || item.includes('B'));
    const includesSaOrBOrLI = auth.userRole.some(item => item.includes('SA') || item.includes('B') || item.includes('LI'));
    if(!includesSaOrB){   
      setAccessandRoleDisable(true);
      setRequestor_buttonStyle({ opacity: 0.6, background: 'lightgrey', cursor: 'none',textTransform: 'none' })
    }
   if(!includesSaOrBOrLI){    
      setLinkageProjectDisable(true);
      setLinkage_buttonStyle({ opacity: 0.6, background: 'lightgrey', cursor: 'none',textTransform: 'none' })
    }

  },[])
  const handleAprroval=()=>{
    history.push("/unbooked-hrs-report")
  }
  const handleUnReviewed=()=>{
    history.push("/pending-booking-approval-report")
  }
  const handleUnBooked=()=>{
    history.push("/unbooked-hrs-report")
  }

  const handleReporteUnRewied=()=>{
    history.push("/time-booking-review")
  }

  const handleOperativeUnBooked=()=>{
    history.push("/unbooked-hrs-report")
  }

  const [ reqDashboardfilterData, setReqDashboardfilterData] = useState({
    myreq_Cnt: {
      user_id: auth.personNumber,
      req_type: "created",
      request_status: null,
      start_date:"",
      end_date: "",
    },
    myapp_Cnt: {
      user_id: auth.personNumber,
      req_type: "approval",
      request_status: null,
      start_date:"",
      end_date: "",
    }
  });
    
   const [ linkageDashfilterData, setLinkageDashfilterData] = useState({
   myreq_Cnt: {
    user_id: auth.personNumber,
    req_type: "created",
    request_status: null,
    start_date:"",
    end_date: "",
    },
   myapp_Cnt: {
    user_id: auth.personNumber,
    req_type: "approval",
    request_status: null,
    start_date: "",
    end_date: "",
   }
  });

  const handleAccessRole=(event)=>{
    const val = event.target.getAttribute('name');
    const isExactMatchRole = (userRole) => userRole.length === 1 && userRole.includes("B");

    if (ipAddress2 && !isExactMatchRole(auth.userRole)) {
      if(val == 'created'){

        history.push({
          pathname: '/linkage-dashboard',
          state: { data: linkageDashfilterData.myreq_Cnt}
        });
        dispatch(setLogin({ ...auth, apiSendData: undefined}));
      }else{
        history.push({
          pathname: '/linkage-dashboard',
          state: { data: linkageDashfilterData.myapp_Cnt}
        });
        dispatch(setLogin({ ...auth, apiSendData: undefined}));
      }
    }else{
      const msg = isExactMatchRole(auth.userRole) ? 'You are not authorized to access this page.' : 'This link is not accessible on internet' ;
      showPopup({
        type: MESSAGE_TYPE.INFORMATION,
         contextText: MESSAGE_TYPE.INFORMATION,
        //  info: 'This link is not accessible on internet',
        info: msg,
       });
    }
  }

   const handleReuestorBoard = (event) => {
    const val = event.target.getAttribute('name');
      if (ipAddress2) {
        if(val == 'created'){

          history.push({
            pathname: '/requestor-dashboard',
            state: { data: reqDashboardfilterData.myreq_Cnt }
          });
          dispatch(setLogin({ ...auth, apiSendData: undefined}));

        }else{
          history.push({
            pathname: '/requestor-dashboard',
            state: { data: reqDashboardfilterData.myapp_Cnt }
          });
          dispatch(setLogin({ ...auth, apiSendData: undefined}));
        }
      }else{
      showPopup({
        type: MESSAGE_TYPE.INFORMATION,
         contextText: MESSAGE_TYPE.INFORMATION,
         info: 'This link is not accessible on internet',
       });
    }
  }       

  return (
    <div className={styles.container}>
      <Grid
        container
        spacing={1}
        columns={12}
      >
        <Grid item md={12} lg={12} xs={12} >
          <Grid container>         
          {dsReviewRole ? 
            <Grid item md={4} lg={4} xs={6}  sm={6}  onClick={handleUnReviewed}>     
            <Grid  className={styles.grid_design_right}>
             <p style={{margin:"3px"}}>Dept. Un-Reviewed<span style={{float:"right"}}><BriefCase /></span></p>
             <p style={{margin:"3px"}}>{unBookedUnreviewed.unreviewedhrstotal_hours} hrs</p>   
            </Grid>          
           </Grid>:""    
        }  
        {dsReviewRole ? 
        <Grid item md={4} lg={4} xs={6} sm={6} onClick={handleUnBooked}> 
        <Grid className={styles.grid_design}>
        <p style={{margin:"3px"}}> Dept. Un-Booked<span style={{float:"right"}}><BriefCase /></span></p>
          <p style={{margin:"3px"}}>{unBookedUnreviewed.unbookedtotal_hours} hrs</p>   
          </Grid>              
        </Grid>:""}  
            {managerRole ?
            <Grid item md={4} lg={4} xs={6}  sm={6}  onClick={handleAprroval}>     
               <Grid  className={styles.grid_design_right}>
               <p style={{margin:"3px"}}>Reportee Un-booked hrs<span style={{float:"right"}}><GroupIcon /></span></p>
                <p style={{margin:"3px"}}>{reporteeUnbook.totalUnbook_hours} hrs</p>   
               </Grid>          
            </Grid>:""}
            {managerRole ? 
               <Grid item md={4} lg={4} xs={6} sm={6} onClick={handleReporteUnRewied}> 
               <Grid className={styles.grid_design}>
               <p style={{margin:"3px"}}>Reportee  Un-reviewed hrs<span style={{float:"right"}}><GroupIcon /></span></p>
                  <p style={{margin:"3px"}}>{pendingCount.total_hours} hrs</p>  
                 </Grid>              
               </Grid>:""    
          }
          {supervisorRole ?
           <Grid item md={4} lg={4} xs={6}  sm={6}  onClick={handleOperativeUnBooked}>     
           <Grid  className={styles.grid_design_right}>
           <p style={{margin:"3px"}}>Operative Un-Booked hrs<span style={{float:"right"}}><GroupIcon /></span></p>
            <p style={{margin:"3px"}}>{operavtiveData.operative_unbookedHrs} hrs</p> 
           </Grid>          
           </Grid>:"" 
        }   
          </Grid>
  {ipAddress2 &&
            <Grid className={styles.grid_design} container style={{padding: '1% 3% 1% 3%', paddingLeft: '0px'}}>
                <Grid item md={6} lg={6} xs={6} sm={6}> 
                <Grid className="">
                <div style={{textAlign: "center"}}>
                <label><strong>Pending Access & Role</strong></label>
                  </div>
                </Grid>
                  <div> 
                    <Grid className={styles.grid_design}>
                      <Button variant="outlined" name="created" style={{textTransform: 'none'}} className={styles.btnTabcss} endIcon={<ArticleIcon className={styles.iconCss}/>} onClick={handleReuestorBoard}>
                      My Requests (Raised by me) <span style={{marginLeft:"39%"}}><strong>{accessAndRoleManagementStatusCountData.my_req_count ? accessAndRoleManagementStatusCountData.my_req_count : 0}</strong></span>
                      </Button>
                    </Grid>

                    <Grid className={styles.grid_design}>
                      <Button variant="outlined" name="approval" className={styles.btnTabcss} endIcon={<AccessTimeFilledIcon className={styles.iconCss}/>} onClick={handleReuestorBoard} disabled={accessandRoleDisable} style={Requestor_buttonStyle}>
                      My Approval (Pending on me)<span style={{marginLeft:"38%"}}><strong>{accessAndRoleManagementStatusCountData.my_approval_count ? accessAndRoleManagementStatusCountData.my_approval_count : 0}</strong></span>
                      </Button>
                      </Grid>
                  </div>
                </Grid>

            <Grid item md={6} lg={6} xs={6} sm={6}>     
            <Grid  className="">
                <div style={{textAlign: "center"}}>
                <label><strong>Pending Project Linkage</strong></label>
                </div>
              </Grid>
                <div> 
                    <Grid  className={styles.grid_design_right}>
                    <Button variant="outlined" name="created" style={{textTransform: 'none'}} className={styles.btnTabcss} endIcon={<ArticleIcon className={styles.iconCss}/>} onClick={handleAccessRole}>
                      My Requests (Raised by me) <span style={{marginLeft:"39%"}}><strong>{projectLinkageStatusCountData.my_req_count ? projectLinkageStatusCountData.my_req_count : 0}</strong></span>
                    </Button>
                    </Grid>

                    <Grid  className={styles.grid_design_right}>
                      <Button variant="outlined" name="approval" className={styles.btnTabcss} endIcon={<AccessTimeFilledIcon className={styles.iconCss}/>} onClick={handleAccessRole} disabled={linkageProjectDisable} style={Linkage_buttonStyle}>
                      My Approval (Pending on me)<span style={{marginLeft:"36%"}}><strong>{projectLinkageStatusCountData.my_approval_count ? projectLinkageStatusCountData.my_approval_count : 0}</strong></span>
                    </Button>
                    </Grid>
                </div>
      
            </Grid>
            </Grid>
  }
          <Grid container>
             <Grid className={styles.dashboard_grid}>
              <Announcement
               landingpageRight="true"
              />
            </Grid>
          </Grid>
        </Grid>.
      </Grid>
      {loading==true ? 
          <div style={{textAlign:"center",display:"flex",justifyContent:"center",marginTop:"10px",background:"white", boxShadow:"0px 3px 6px #00000027"}}>
               <Truckloading />
            </div>:''} 
    </div>
  );
};

export default LandingPage;